import { render, staticRenderFns } from "./MyCampaign.vue?vue&type=template&id=20e6c96a"
import script from "./MyCampaign.vue?vue&type=script&lang=js"
export * from "./MyCampaign.vue?vue&type=script&lang=js"
import style0 from "./MyCampaign.vue?vue&type=style&index=0&id=20e6c96a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports